import { listOrgEnrollments } from "./enrollmentHelpers"
import { listOrgCertificates } from "./certHelpers"
import { listOrgProductViews } from "./productViewHelpers"

// Builds the 6-stage funnel with conversion rates between consecutive stages.
// If Product Views hasn't been instrumented yet (0 events logged), the funnel
// starts from Enrollments instead — showing a fabricated "views" number would
// be worse than omitting a stage that isn't tracked yet.
export const computeFunnelData = async (orgId) => {
  const [{ enrollments }, { certificates }, { views }] = await Promise.all([
    listOrgEnrollments(orgId),
    listOrgCertificates(orgId),
    listOrgProductViews(orgId),
  ])

  const viewCount = views?.length || 0
  const enrollmentCount = enrollments?.length || 0
  const startCount = enrollments?.filter((e) => (e?.progressPercent || 0) > 0)?.length || 0
  const progress50Count = enrollments?.filter((e) => (e?.progressPercent || 0) >= 50)?.length || 0
  const completionCount = enrollments?.filter((e) => (e?.progressPercent || 0) >= 100)?.length || 0
  const credentialCount = certificates?.length || 0

  const stages = [
    { key: "views", label: "Product Views", value: viewCount, tracked: viewCount > 0 },
    { key: "enrollments", label: "Enrollments", value: enrollmentCount, tracked: true },
    { key: "starts", label: "Course Starts", value: startCount, tracked: true },
    { key: "progress50", label: "50% Progress", value: progress50Count, tracked: true },
    { key: "completions", label: "Completions", value: completionCount, tracked: true },
    { key: "credentials", label: "Credentials", value: credentialCount, tracked: true },
  ]

  // Drop the Views stage from what's rendered if it isn't tracked yet, rather
  // than showing "0" as if that's a real observed value.
  const visibleStages = stages?.filter((s) => s?.tracked)

  const withConversions = visibleStages?.map((stage, i) => {
    if (i === 0) return { ...stage, stepConversion: null }
    const prev = visibleStages?.[i - 1]
    const stepConversion = prev?.value > 0 ? Math.round((stage?.value / prev?.value) * 1000) / 10 : 0
    return { ...stage, stepConversion }
  })

  return { stages: withConversions, viewsTracked: viewCount > 0 }
}